// Vuex
import { defaultObj } from './state'

export default {
  setBrands (state, brandData) {
    if (brandData.brands) {
      state.brands = brandData.brands
    }
  },

  setBrandedLinks (state, data) {
    // Auto Dialer
    if (data.c1lAutoDailerUrl) {
      state.c1lAutoDailerUrl = data.c1lAutoDailerUrl
    }

    if (data.cccAutoDailerUrl) {
      state.cccAutoDailerUrl = data.cccAutoDailerUrl
    }

    if (data.ccfAutoDailerUrl) {
      state.ccfAutoDailerUrl = data.ccfAutoDailerUrl
    }

    if (data.chsAutoDailerUrl) {
      state.chsAutoDailerUrl = data.chsAutoDailerUrl
    }

    if (data.cicAutoDailerUrl) {
      state.cicAutoDailerUrl = data.cicAutoDailerUrl
    }

    if (data.esmAutoDailerUrl) {
      state.esmAutoDailerUrl = data.esmAutoDailerUrl
    }

    if (data.inlAutoDailerUrl) {
      state.inlAutoDailerUrl = data.inlAutoDailerUrl
    }

    if (data.tbsAutoDailerUrl) {
      state.tbsAutoDailerUrl = data.tbsAutoDailerUrl
    }

    if (data.tmxAutoDailerUrl) {
      state.tmxAutoDailerUrl = data.tmxAutoDailerUrl
    }

    // Econsent
    if (data.c1lEconsentUrl) {
      state.c1lEconsentUrl = data.c1lEconsentUrl
    }

    if (data.cccEconsentUrl) {
      state.cccEconsentUrl = data.cccEconsentUrl
    }

    if (data.ccfEconsentUrl) {
      state.ccfEconsentUrl = data.ccfEconsentUrl
    }

    if (data.chsEconsentUrl) {
      state.chsEconsentUrl = data.chsEconsentUrl
    }

    if (data.cicEconsentUrl) {
      state.cicEconsentUrl = data.cicEconsentUrl
    }

    if (data.esmEconsentUrl) {
      state.esmEconsentUrl = data.esmEconsentUrl
    }

    if (data.inlEconsentUrl) {
      state.inlEconsentUrl = data.inlEconsentUrl
    }

    if (data.tbsEconsentUrl) {
      state.tbsEconsentUrl = data.tbsEconsentUrl
    }

    if (data.tmxEconsentUrl) {
      state.tmxEconsentUrl = data.tmxEconsentUrl
    }

    // Privacy Policy
    if (data.c1lPrivacyPolicyUrl) {
      state.c1lPrivacyPolicyUrl = data.c1lPrivacyPolicyUrl
    }

    if (data.cccPrivacyPolicyUrl) {
      state.cccPrivacyPolicyUrl = data.cccPrivacyPolicyUrl
    }

    if (data.ccfPrivacyPolicyUrl) {
      state.ccfPrivacyPolicyUrl = data.ccfPrivacyPolicyUrl
    }

    if (data.chsPrivacyPolicyUrl) {
      state.chsPrivacyPolicyUrl = data.chsPrivacyPolicyUrl
    }

    if (data.cicPrivacyPolicyUrl) {
      state.cicPrivacyPolicyUrl = data.cicPrivacyPolicyUrl
    }

    if (data.esmPrivacyPolicyUrl) {
      state.esmPrivacyPolicyUrl = data.esmPrivacyPolicyUrl
    }

    if (data.inlPrivacyPolicyUrl) {
      state.inlPrivacyPolicyUrl = data.inlPrivacyPolicyUrl
    }

    if (data.tbsPrivacyPolicyUrl) {
      state.tbsPrivacyPolicyUrl = data.tbsPrivacyPolicyUrl
    }

    if (data.tmxPrivacyPolicyUrl) {
      state.tmxPrivacyPolicyUrl = data.tmxPrivacyPolicyUrl
    }

    // Terms Conditions
    if (data.c1lTermsConditionsUrl) {
      state.c1lTermsConditionsUrl = data.c1lTermsConditionsUrl
    }

    if (data.cccTermsConditionsUrl) {
      state.cccTermsConditionsUrl = data.cccTermsConditionsUrl
    }

    if (data.ccfTermsConditionsUrl) {
      state.ccfTermsConditionsUrl = data.ccfTermsConditionsUrl
    }

    if (data.chsTermsConditionsUrl) {
      state.chsTermsConditionsUrl = data.chsTermsConditionsUrl
    }

    if (data.cicTermsConditionsUrl) {
      state.cicTermsConditionsUrl = data.cicTermsConditionsUrl
    }

    if (data.esmTermsConditionsUrl) {
      state.esmTermsConditionsUrl = data.esmTermsConditionsUrl
    }

    if (data.inlTermsConditionsUrl) {
      state.inlTermsConditionsUrl = data.inlTermsConditionsUrl
    }

    if (data.tbsTermsConditionsUrl) {
      state.tbsTermsConditionsUrl = data.tbsTermsConditionsUrl
    }

    if (data.tmxTermsConditionsUrl) {
      state.tmxTermsConditionsUrl = data.tmxTermsConditionsUrl
    }

    // Store Locator
    if (data.c1lStoreLocatorSiteUrl) {
      state.c1lStoreLocatorSiteUrl = data.c1lStoreLocatorSiteUrl
    }

    if (data.cccStoreLocatorSiteUrl) {
      state.cccStoreLocatorSiteUrl = data.cccStoreLocatorSiteUrl
    }

    if (data.ccfStoreLocatorSiteUrl) {
      state.ccfStoreLocatorSiteUrl = data.ccfStoreLocatorSiteUrl
    }

    if (data.chsStoreLocatorSiteUrl) {
      state.chsStoreLocatorSiteUrl = data.chsStoreLocatorSiteUrl
    }

    if (data.cicStoreLocatorSiteUrl) {
      state.cicStoreLocatorSiteUrl = data.cicStoreLocatorSiteUrl
    }

    if (data.esmStoreLocatorSiteUrl) {
      state.esmStoreLocatorSiteUrl = data.esmStoreLocatorSiteUrl
    }

    if (data.inlStoreLocatorSiteUrl) {
      state.inlStoreLocatorSiteUrl = data.inlStoreLocatorSiteUrl
    }

    if (data.tbsStoreLocatorSiteUrl) {
      state.tbsStoreLocatorSiteUrl = data.tbsStoreLocatorSiteUrl
    }

    if (data.tmxStoreLocatorSiteUrl) {
      state.tmxStoreLocatorSiteUrl = data.tmxStoreLocatorSiteUrl
    }
  },

  reset (state) {
    state = Object.assign(state, defaultObj)
    if (this.cache.has('brands/getBrands') === true) {
      this.cache.delete('brands/getBrands')
    }
  }
}
